'use es6';

import PropTypes from 'prop-types';
import defaultIcon from 'bender-url!../../img/favicon.png';
import darkIcon from 'bender-url!../../img/favicon-dark.png';
import { jsx as _jsx } from "react/jsx-runtime";
const getFavicon = () => window.matchMedia('(prefers-color-scheme: dark)').matches ? darkIcon : defaultIcon;
const Favicon = ({
  rel = 'shortcut icon',
  type = 'image/png'
}) => {
  return /*#__PURE__*/_jsx("link", {
    rel: rel,
    type: type,
    href: getFavicon()
  });
};
Favicon.propTypes = {
  type: PropTypes.string.isRequired,
  rel: PropTypes.string.isRequired
};
export default Favicon;